import moment from 'moment';

// Doubt/tracking rows store their time as an epoch string (e.g. "1787807339"),
// but older rows may already carry a formatted date. Handle both.
export const parseDoubtTime = (value) => {
    if (value === null || value === undefined || value === '') return null;

    const raw = value.toString().trim();
    if (/^\d{13}$/.test(raw)) return moment(parseInt(raw, 10));
    if (/^\d{9,11}$/.test(raw)) return moment.unix(parseInt(raw, 10));

    const parsed = moment(raw, ["YYYY-MM-DD HH:mm:ss", "YYYY-MM-DD", moment.ISO_8601], false);
    return parsed.isValid() ? parsed : null;
};

// Font Awesome glyph that suits the subject, falling back to a generic book.
export const getSubjectIcon = (subjectName) => {
    const name = (subjectName || '').toLowerCase();

    if (name.includes('physic')) return 'fas fa-atom';
    if (name.includes('chemist')) return 'fas fa-flask';
    if (name.includes('botan') || name.includes('plant')) return 'fas fa-leaf';
    if (name.includes('zoolog')) return 'fas fa-paw';
    if (name.includes('biolog')) return 'fas fa-dna';
    if (name.includes('math')) return 'fas fa-square-root-alt';
    if (name.includes('english') || name.includes('language')) return 'fas fa-language';
    if (name.includes('comput')) return 'fas fa-laptop-code';
    return 'fas fa-book';
};

export const formatDoubtTime = (value) => {
    const parsed = parseDoubtTime(value);
    if (!parsed) return '';

    const now = moment();
    if (parsed.isSame(now, 'day')) return `Today, ${parsed.format('h:mm A')}`;
    if (parsed.isSame(now.clone().subtract(1, 'day'), 'day')) return `Yesterday, ${parsed.format('h:mm A')}`;
    if (parsed.isSame(now, 'year')) return parsed.format('DD MMM, h:mm A');
    return parsed.format('DD MMM YYYY, h:mm A');
};
